import { httpClient } from 'shared/api/http-client'
import { RestorePasswordInterface } from '../types/restore-password-interface'
import { RESTORE_PASSWORD_API } from './constants'

export function restorePassword(body: RestorePasswordInterface) {
  return httpClient.post(RESTORE_PASSWORD_API, body)
}
